const DEPRECATED_ALGORITHM_NAMES = new Set([
  'reconhecimento facial',
  'detecção de cinto de segurança',
  'detecção de capacete'
]);

export const filterAllowedAlgorithms = (algorithms = []) => {
  if (!Array.isArray(algorithms)) return [];
  return algorithms.filter(algo => {
    const name = String(algo?.name || '').toLowerCase();
    return !DEPRECATED_ALGORITHM_NAMES.has(name);
  });
};
